/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { Button, Form, Modal } from 'antd';
import { useEffect } from 'react';
import EditorPrivacy from '../../../../../components/Shared/forms/EditorPrivacy';
import TemplateDesignService from '../../../../../services/TemplateDesign.service';
import { v4 as uuidv4 } from 'uuid';

const ModalAddNote = ({
    open,
    handelClose,
    mode,
    setAddNote,
    setTriggerNote,
    templateId,
    noteObject,
    edit,
    setNotes,
    notes,

    triggerNote,
    combinedDragData,
    setCombinedDragData,
    setFakeNote,
}) => {
    const [form] = Form.useForm();
    const { t } = useTranslation('consent');

    const clear = () => {
        form.resetFields();
    };
    useEffect(() => {
        if (mode === 'editNote') {
            form.setFieldsValue({
                titleTh: noteObject.titleTh,
                titleEn: noteObject.titleEn,
            });
        }
    }, [noteObject]);

    useEffect(() => {
        if (mode === 'addNote') {
            form.setFieldsValue({
                titleTh: '',
                titleEn: '',
            });
        }
    }, [open]);

    const onSubmit = async (e) => {
        if (edit) {
            if (mode === 'addNote') {
                // Create mode
                handelClose();
                await TemplateDesignService.createNote({
                    ...e,
                    templateDesignId: templateId,
                })
                    .then((res) => {
                        setTriggerNote(!triggerNote);
                        const addNewNote = {
                            consentTxnGroupId: null,
                            consentId: null,
                            sequence: combinedDragData.length + 1,
                            consentNameTh: null,
                            consentNameEn: null,
                            isConsented: null,
                            purposeTh: null,
                            purposeEn: null,
                            type: null,
                            noteId: res?.data?.resultData?.noteId,
                            titleTh: e.titleTh,
                            titleEn: e.titleEn,
                        };

                        setAddNote(addNewNote);
                        clear();
                        handelOk();
                    })
                    .catch((err) => {
                        console.log('err', err);
                    });
            } else if (mode === 'editNote') {
                // Edit mode
                handelClose();
                await TemplateDesignService.editNote({
                    ...e,
                    noteId: noteObject.noteId,
                    templateDesignId: templateId,
                })
                    .then((res) => {
                        setTriggerNote(!triggerNote);
                        setCombinedDragData((prevData) =>
                            prevData.map((item) => {
                                if (
                                    item.noteId ===
                                    res?.data?.resultData?.noteId
                                ) {
                                    return {
                                        ...item,
                                        titleTh: e.titleTh,
                                        titleEn: e.titleEn,
                                    };
                                }
                                return item;
                            })
                        );

                        clear();
                        handelOk();
                    })
                    .catch((err) => {
                        console.log('err', err);
                    });
            }
        } else {
            handelClose();
            if (mode === 'editNote') {
                const foundNote = notes.find(
                    (item) => item.noteId === noteObject.noteId
                );
                if (foundNote) {
                    foundNote.titleTh = e.titleTh;
                    foundNote.titleEn = e.titleEn;
                }
                setNotes([...notes]);
                setCombinedDragData((prevData) =>
                    prevData.map((item) => {
                        if (item.noteId === foundNote.noteId) {
                            return {
                                ...item,
                                titleTh: foundNote.titleTh,
                                titleEn: foundNote.titleEn,
                            };
                        }
                        return item;
                    })
                );
                clear();
            } else {
                const newNote = [
                    ...notes,
                    {
                        ...e,
                        noteId: uuidv4(),
                        templateDesignId: null,
                    },
                ];
                setNotes(newNote);
                setFakeNote(newNote);
                form.resetFields();
                clear();
            }
        }
    };

    const handelOk = () => {
        handelClose();
    };

    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            centered
            onCancel={() => {
                handelClose();
                clear();
            }}
        >
            <div>
                <div className="text-2xl font-semibold pb-2 text-center">
                    {mode === 'addNote' ? t('add note') : t('edit note')}
                </div>
                <Form form={form} layout="vertical" onFinish={onSubmit}>
                    <Form.Item
                        name="titleTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Note')} (TH)
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('RequiredField'),
                            },
                        ]}
                    >
                        <EditorPrivacy className="min-note" />
                    </Form.Item>
                    <Form.Item
                        name="titleEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Note')} (EN)
                            </span>
                        }
                    >
                        <EditorPrivacy className="min-note" />
                    </Form.Item>
                    <div className="flex justify-center items-center space-x-4 pt-2">
                        <Button
                            type="primary"
                            style={{ padding: '0px 30px' }}
                            onClick={() => {
                                handelClose();
                                clear();
                            }}
                            size="large"
                            ghost
                        >
                            {t('Cancel')}
                        </Button>

                        <Button
                            htmlType="submit"
                            size="large"
                            type="primary"
                            style={{ padding: '0px 38px' }}
                        >
                            {t('Confirm')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};
export default ModalAddNote;
